import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { useState } from "react";
import {
  getActiveChannelUuidSelector,
  getChannelListSelector,
  setActiveChannelUuid,
} from "store/reducers/ChannelDetails/channelList";

const ChannelDropdown = () => {
  const channelList = useAppSelector(getChannelListSelector);
  const channelUuid = useAppSelector(getActiveChannelUuidSelector);

  const dispatch = useAppDispatch();

  const [channel, setChannel] = useState(
    channelUuid || channelList[0].channelUuid || ""
  );

  const handleChange = (channel: SelectChangeEvent) => {
    setChannel(channel.target.value);
    dispatch(setActiveChannelUuid(channel.target.value));
  };

  return (
    <div className="">
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Uploading to</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={channel}
          label="Uploading to"
          onChange={handleChange}
        >
          {channelList.map((channel, idx) => {
            if (channel.channelUuid) {
              return (
                <MenuItem key={idx} value={channel.channelUuid}>
                  {channel.channelName}
                </MenuItem>
              );
            }
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default ChannelDropdown;
